(() => {
  function mount(root) {
    if(root.dataset.wpMounted)return;root.dataset.wpMounted='true';
    const links=[...root.querySelectorAll('[data-wp-style]')];
    let photoType;
    const setPhoto=(gallery,key)=>{
      const photos=[...gallery.querySelectorAll('[data-wp-photo]')];
      const selected=photos.find(el=>el.dataset.wpPhoto===key)||photos[0];
      if(!selected)return;
      photos.forEach(el=>{el.hidden=el!==selected;});
      gallery.querySelectorAll('[data-wp-photo-target]').forEach(el=>el.setAttribute('aria-pressed',String(el.dataset.wpPhotoTarget===selected.dataset.wpPhoto)));
    };
    root.querySelectorAll('[data-wp-photo-target]').forEach(button=>button.addEventListener('click',()=>{
      photoType=button.dataset.wpPhotoTarget;
      const gallery=button.closest('[data-wp-visual]');setPhoto(gallery,photoType);
      root.querySelector('[data-wp-status]').textContent=gallery.dataset.wpVisual+': '+button.textContent.trim()+'.';
    }));
    const show=(style,updateUrl=false)=>{
      const link=links.find(el=>el.dataset.wpStyle===style);if(!link)return;
      links.forEach(el=>{if(el===link)el.setAttribute('aria-current','true');else el.removeAttribute('aria-current');});
      for(const type of ['visual','order','spec'])root.querySelectorAll('[data-wp-'+type+']').forEach(el=>{el.hidden=el.dataset['wp'+type[0].toUpperCase()+type.slice(1)]!==style;});
      const gallery=[...root.querySelectorAll('[data-wp-visual]')].find(el=>el.dataset.wpVisual===style);
      if(gallery)setPhoto(gallery,photoType);
      if(updateUrl){const url=new URL(link.href,location.origin);url.hash='';history.pushState({},'',url);}
      root.querySelector('[data-wp-status]').textContent=style+' selected. Preview, ordering and specifications updated.';
    };
    links.forEach(link=>link.addEventListener('click',event=>{if(event.button||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey)return;event.preventDefault();show(link.dataset.wpStyle,true);}));
    const first=links.find(el=>el.hasAttribute('aria-current'))||links[0];
    window.addEventListener('popstate',()=>{const id=new URLSearchParams(location.search).get('variant');show((links.find(el=>el.dataset.wpRollId===id||el.dataset.wpSampleId===id)||first)?.dataset.wpStyle);});
    root.querySelectorAll('[data-wp-roll-form], [data-wp-sample-form]').forEach(form=>{
      const qty=form.querySelector('[data-wp-qty]'),total=form.querySelector('[data-wp-total]');
      const coverage=form.querySelector('[data-wp-coverage]'),submit=form.querySelector('[type="submit"]');
      const min=Number(qty.getAttribute('min'))||1,step=Number(qty.getAttribute('step'))||1;
      const max=qty.hasAttribute('max')?Number(qty.getAttribute('max')):Infinity;
      const buttons=[...form.querySelectorAll('[data-wp-step]')];
      const format=new Intl.NumberFormat(undefined,{style:'currency',currency:root.dataset.currency||'USD'});
      const update=()=>{
        const n=Number(qty.value),valid=qty.value.trim()!==''&&Number.isInteger(n)&&n>=min&&n<=max&&(n-min)%step===0;
        submit.disabled=!valid;
        buttons.forEach(button=>{button.disabled=valid&&(Number(button.dataset.wpStep)<0?n-step<min:n+step>max);});
        if(total)total.textContent=valid?format.format(Number(qty.dataset.wpPrice)*n/100):'Choose a quantity';
        if(coverage)coverage.textContent=valid?Number((n*56.25).toFixed(2))+' sq ft of material':'';
      };
      buttons.forEach(button=>button.addEventListener('click',()=>{
        const n=Number(qty.value),direction=Number(button.dataset.wpStep);
        const index=Number.isFinite(n)&&qty.value.trim()!==''?(n-min)/step:0;
        const next=direction>0?Math.floor(index)+1:Math.ceil(index)-1;
        const last=Number.isFinite(max)?min+Math.floor((max-min)/step)*step:Infinity;
        qty.value=String(Math.max(min,Math.min(last,min+next*step)));update();
      }));
      qty.addEventListener('input',update);update();
    });
  }
  const boot=()=>document.querySelectorAll('[data-wp-product]').forEach(mount);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
  document.addEventListener('shopify:section:load',boot);
})();
